import { MAX_VISIBLE_PAGINATION_ITEMS } from '../constants';
export const isNextSlide = ({
  currentSlide,
  maxVisibleItems = MAX_VISIBLE_PAGINATION_ITEMS,
  slidesCount,
  slideIndex
}) => slidesCount > maxVisibleItems && slideIndex === currentSlide + 2;
//# sourceMappingURL=isNextSlide.js.map